import * as React from "react";
import { forwardRef } from "react";
const SvgBloodDrop = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "blood_drop (2)" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M17.5 14.4605C17.5 17.4411 15.0376 19.8574 12 19.8574C8.96243 19.8574 6.5 17.4411 6.5 14.4605C6.5 9.7383 12 4.14307 12 4.14307C12 4.14307 17.5 9.7383 17.5 14.4605Z", fill: "#334A74" })));
const ForwardRef = forwardRef(SvgBloodDrop);
export default ForwardRef;
